import {ChartConfiguration} from 'chart.js';
import 'chartjs-plugin-datalabels';

/**
 * This abstract class contains all options, needed to display a bar chart.
 */
export abstract class BarChartOptions {

  /**
   * Bar chart options for daily and weekly footfall predictions.
   */
  static getChartOptions(): ChartConfiguration['options'] {
    return {
      plugins: {
        datalabels: {
          anchor: 'end',
          align: 'end',
          offset: -5,
          font: (context) => {
            return {
              weight: 'bold',
              size: this.isMaxElement(context) ? 16 : 12
            };
          },
          color: (context) => {
            if (this.isMaxElement(context)) {
              return '#aa000c';
            }
          }
        },
        tooltip: {
          titleFont: {
            size: 15
          },
          callbacks: {
            title: () => '',
            label: item => {
              return 'Predicted footfall ' + Number(item.parsed.y);
            }
          }
        },
        legend: {
          display: false
        }
      },
      responsive: true,
      maintainAspectRatio: false,
      scales: {
        y: {
          beginAtZero: true,
          ticks: {
            autoSkip: true,
          },
          grid: {display: true},
          border: {display: false},
        },
        x: {
          grid: {display: false},
          border: {display: false},
        }
      },
    };
  }

  private static isMaxElement(context): boolean {
    const data = context.dataset.data;
    const max = data
            .reduce((previous, current) => current > previous ? current : previous);
    return data[context.dataIndex] === max;
  }
}